//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { IStreamSource } from '@streams-drawer/model/IStreamSource';
import { StreamSourceTypes } from '@streams/constants/streamCreationConstants';
import { getUsedHashtagsLowercase } from '@streams/selectors/getUsedHashtagsLowercase';

export const getUnusedAddedHashtagCountImpl = (usedHashtags: string[], sourcesAdded: IStreamSource[]) => {
  const addedHashtags = sourcesAdded.
      filter((source: IStreamSource) => source.sourceType === StreamSourceTypes.HASHTAG).
      map((source: IStreamSource) => source.sourceValue.toLowerCase());

  const newAddedHashtags = addedHashtags.filter((hashtag: string) => !usedHashtags.includes(hashtag));

  return newAddedHashtags.length;
};

// Returns the number of hashtags added to a stream that would increment the tracked hashtag count.
// I.e. totalNumAddedHashtags - numAddedHashtagsAlreadyContributingToHashtagLimit
export const getUnusedAddedHashtagCount = createSelector(
  (state: ICuralateStore) => getUsedHashtagsLowercase(state),
  (state: ICuralateStore) => state.streams.streamCreation.sourcesAdded,
  getUnusedAddedHashtagCountImpl
);

export default getUnusedAddedHashtagCount;
